






















































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import { common } from '@/app/model/store/domain/const'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'

import NewsBoardCreateApi from '@/app/model/api/newsBoardCreateApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import NewsBoardValidator from '@/app/module/validator/newsBoardValidator'
import VarietyListApi from '@/app/model/api/varietyListApi'
import DistrictListApi from '@/app/model/api/districtListApi'
import NewsBoardDetailApi from '@/app/model/api/newsBoardDetailApi'
import NewsBoardEditApi from '@/app/model/api/newsBoardEditApi'
import NewsBoardDeleteApi from '@/app/model/api/newsBoardDeleteApi'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  },
  metaInfo (this: NewsBoardCreate): MetaInfo {
    return {
      title: this.setPageTitle
    }
  }
})
export default class NewsBoardCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private newsBoardName: string = ''
  private newsBoardId: string = ''
  private categoryId: number = 1
  private constantValue: any = []

  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  private createModeFlag: boolean = true

  private selectedVarietyOptions: any = [
    { text: 'すべて', value: 1 },
    { text: '選択', value: 0 }
  ]
  private selectedDistrictOptions: any = [
    { text: 'すべて', value: 1 },
    { text: '選択', value: 0 }
  ]
  private varietySelected: number = 1
  private districtSelected: number = 1
  private varietyData: any = []
  private districtData: any = []
  private selectedVarietyValue: any = []
  private selectedDistrictValue: any = []
  private newsBoardDetailData: any = {}
  private newsBoardTitle: string = ''
  private newsBoardHeaderTitle: string = ''

  private get setPageTitle () {
    let title = ''
    if (this.$route.path === '/news-board/create') {
      title = CommonClass.getServiceFunctionData().news_board.news_board_name + '追加 | ' + common.SYSTEM_NAME
    } else {
      title = CommonClass.getServiceFunctionData().news_board.news_board_name + '編集・削除 | ' + common.SYSTEM_NAME
    }
    return title
  }

  created () {
    window.scrollTo(0, 0)
    this.getVarieties()
    this.getDistricts()
    this.newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.$route.path === '/news-board/create') {
      this.createModeFlag = true
      this.newsBoardHeaderTitle = this.newsBoardTitle + '追加'
    } else {
      this.createModeFlag = false
      this.newsBoardId = this.$route.params.news_board_id
      this.newsBoardHeaderTitle = this.newsBoardTitle + '編集・削除'
      this.getNewsBoardDetail(this.newsBoardId)
    }
  }

  private saveNewsBoard () {
    if (this.validNewsBoard()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    if (this.createModeFlag) {
      this.createNewsBoard()
    } else {
      this.updateNewsBoard()
    }
  }

  private async createNewsBoard () {
    const requestBody: any = {
      news_bord_name: this.newsBoardName,
      category_id: this.categoryId,
      variety: {
        is_all_varieties: this.varietySelected === 1,
        variety_options: NewsBoardCreate.selectedVarietyContentsIfNeeded(this.varietySelected, this.selectedVarietyValue)
      },
      district: {
        is_all_districts: this.districtSelected === 1,
        district_options: NewsBoardCreate.selectedDistrictContentsIfNeeded(this.districtSelected, this.selectedDistrictValue)
      }
    }

    const result = await NewsBoardCreateApi.doNewsBoardCreate(requestBody)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.newsBoardTitle + '登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      const payload = result.getPayload()
      this.$router.push('/news-board/' + payload.news_board_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private static selectedVarietyContentsIfNeeded (isAll: number, data: any) {
    if (isAll === 1) {
      return []
    }

    const varietyContents = []
    for (const datum of data) {
      varietyContents.push({
        variety_id: datum
      })
    }
    return varietyContents
  }

  private static selectedDistrictContentsIfNeeded (isAll: number, data: any) {
    if (isAll === 1) {
      return []
    }

    const districtContents = []
    for (const datum of data) {
      districtContents.push({
        district_id: datum
      })
    }
    return districtContents
  }

  private validNewsBoard (): boolean {
    let isValid = false
    if (NewsBoardValidator.validRequireNewsBoardName('newsBoardNameErrorMessage', this.newsBoardName)) {
      isValid = true
    }

    if (NewsBoardValidator.validMaxLengthNewsBoardName('newsBoardNameMaxLengthErrorMessage', this.newsBoardName)) {
      isValid = true
    }

    if (NewsBoardValidator.validSelectedVarietyType('selectedVarietyTypeErrorMessage', this.varietySelected)) {
      isValid = true
    }

    if (NewsBoardValidator.validSelectedDistrictType('selectedDistrictTypeErrorMessage', this.districtSelected)) {
      isValid = true
    }

    if (NewsBoardValidator.validRequiredVariety('requiredVarietyErrorMessage', this.varietySelected, this.selectedVarietyValue)) {
      isValid = true
    }

    if (NewsBoardValidator.validRequiredDistrict('requiredDistrictErrorMessage', this.districtSelected, this.selectedDistrictValue)) {
      isValid = true
    }

    this.errorMessages = NewsBoardValidator.getErrorMessage()
    return isValid
  }

  private async updateNewsBoard () {
    const requestBody: any = {
      news_bord_name: this.newsBoardName,
      category_id: this.categoryId,
      variety: {
        is_all_varieties: this.varietySelected === 1,
        variety_options: NewsBoardCreate.selectedVarietyContentsIfNeeded(this.varietySelected, this.selectedVarietyValue)
      },
      district: {
        is_all_districts: this.districtSelected === 1,
        district_options: NewsBoardCreate.selectedDistrictContentsIfNeeded(this.districtSelected, this.selectedDistrictValue)
      },
      time_stamp: this.newsBoardDetailData.time_stamp
    }

    const result = await NewsBoardEditApi.doNewsBoardEdit(this.newsBoardId, requestBody)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.newsBoardTitle + '編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/news-board/' + this.$route.params.news_board_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private getNewsBoardDetail (newsBoardId: string) {
    (async () => {
      const result = await NewsBoardDetailApi.getDetail(newsBoardId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.newsBoardDetailData = payload
        this.newsBoardName = payload.news_board_name
        this.varietySelected = payload.variety.is_all_varieties ? 1 : 0
        this.selectedVarietyValue = this.choiceVarietyOptions(payload.variety.variety_options)
        this.districtSelected = payload.district.is_all_districts ? 1 : 0
        this.selectedDistrictValue = this.choiceDistrictOptions(payload.district.district_options)
        this.categoryId = payload.category_id
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private choiceVarietyOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.variety_id)
    }

    return ret
  }

  private choiceDistrictOptions (data: any) {
    let ret = []

    for (const datum of data) {
      ret.push(datum.district_id)
    }

    return ret
  }

  private doNewsBoardDelete () {
    (async () => {
      const result = await NewsBoardDeleteApi.doNewsBoardDelete(this.newsBoardId)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.newsBoardTitle + 'を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/news-board').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private doCancel () {
    if (this.createModeFlag) {
      this.$router.push('/news-board').catch(e => {})
    } else {
      this.$router.push('/news-board/' + this.newsBoardId).catch(e => {})
    }
  }

  // 品種情報取得
  private getVarieties () {
    (async () => {
      const data = {
        word: '',
        order_name: 'variety_name',
        sort: true
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから操作をしてください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  /* 地区取得 */
  private getDistricts () {
    (async () => {
      this.showLoading = true
      const data : any = {
        sortName: 'district_name',
        sort: 'asc',
        text: ''
      }

      const result = await DistrictListApi.getDistrictList(data)

      if (result.isOk()) {
        this.districtData = result.getPayload().results
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }
}
